/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_TitleInputs */

const es_components_upgrade_plan_modal_title = /** @type {(inputs: Components_Upgrade_Plan_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegí el plan ideal para tu equipo`)
};

const en_components_upgrade_plan_modal_title = /** @type {(inputs: Components_Upgrade_Plan_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose the ideal plan for your team`)
};

/**
* | output |
* | --- |
* | "Choose the ideal plan for your team" |
*
* @param {Components_Upgrade_Plan_Modal_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_title = /** @type {((inputs?: Components_Upgrade_Plan_Modal_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_title(inputs)
	return en_components_upgrade_plan_modal_title(inputs)
});
export { components_upgrade_plan_modal_title as "components.upgrade_plan_modal.title" }